<h1>{{ 'nav.teams' | translate }}</h1>

<div size="tiny" [nbSpinner]="loading"
     nbSpinnerStatus="danger"
     nbSpinnerSize="large"
     nbSpinnerMessage="">
  <app-division-selector [divisions]="divisions()"
                         [selectedDivisionId]="selectedDivisionId"
                         (divisionChanged)="onDivisionChange($event)"></app-division-selector>

  <h2>{{ 'admin.groups.group' | translate }} A</h2>
  <app-teams-list [isLoggedIn]="isLoggedIn" [teams]="teamsA()"></app-teams-list>

  <hr>
  <h2 class="mt-8">{{ 'admin.groups.group' | translate }} B</h2>
  <app-teams-list [isLoggedIn]="isLoggedIn" [teams]="teamsB()"></app-teams-list>

  @if(groups().length > 2) {
    <hr>
    <h2 class="mt-8">{{ 'admin.groups.group' | translate }} C</h2>
    <app-teams-list [isLoggedIn]="isLoggedIn" [teams]="teamsC()"></app-teams-list>
  }

  @if(groups().length > 3) {
    <hr>
    <h2 class="mt-8">{{ 'admin.groups.group' | translate }} D</h2>
    <app-teams-list [isLoggedIn]="isLoggedIn" [teams]="teamsD()"></app-teams-list>
  }
</div>
